import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import App from "./App";
import CustomThemeProvider from "./theme";
import "./i18n";
import { msalConfig } from "./config/authConfig";

// Import Archivo font weights
import "@fontsource/archivo/400.css";
import "@fontsource/archivo/500.css";
import "@fontsource/archivo/600.css";
import "@fontsource/archivo/700.css";

// Create MSAL instance
const msalInstance = new PublicClientApplication(msalConfig);

// Initialize MSAL - handleRedirectPromise will be called by AuthNavigationHandler
msalInstance.initialize().then(() => {
  console.log("MSAL initialized successfully");

  // Render the app after MSAL initialization
  ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
    // <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <CustomThemeProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </CustomThemeProvider>
      </MsalProvider>
    // </React.StrictMode>
  );
});
